export const SITE_WORKING_CONDITION_ACQUISITION_CARD_FRENCH_LOCALE = {
  title: "Acquisition",
  lastSevenDays: "7 derniers jours",
  tabs: {
    modulators: "Modulateurs",
    pilots: "Pilotes",
    sensors: "Capteurs tiers",
  },
};
